<template>
<div :class="[$style['wrapper'], 'dashboard-list']" v-loading="isLoading">
  <w-dashboard-tree-container ref="dashboardTree" :class="$style['tree']"></w-dashboard-tree-container>
  <el-row type="flex" justify="center" align="middle" :class="$style['btn-bar']" v-if="!isTreeEditMode">
    <span :class="[$style['tree-edit-btn'], 'c-pointer']" @click="onTreeEditClick">
      <i class="fas fa-sliders-h"></i>
      트리 편집
    </span>
  </el-row>
  <el-row type="flex" justify="center" align="middle" :class="$style['btn-bar']" v-else>
    <el-button class="mr-r4" type="secondary" size="small" @click="addDashboardGroup"><i class="far fa-plus"></i>그룹 추가</el-button>
    <el-button class="mr-r4" size="medium" type="primary" @click="onSaveClick">저장</el-button>
    <el-button size="medium" @click="onCancleClick">취소</el-button>
  </el-row>
</div>
</template>

<script>
import DashboardAPI from '@/api/dashboard/common';

import DashboardConst from '@/constants/dashboard';

import Base from '@/mixins/dashboard/base';

import msgUtil from '@/utils/message';

import WDashboardTreeContainer from '@/views/dashboard/components/frame/DashboardTreeContainer';

export default {
  name: 'WDashboardList',
  components: {
    WDashboardTreeContainer,
  },
  mixins: [Base],
  data() {
    return {
      isLoading: false,
    };
  },
  created() {},
  methods: {
    /**
     * 트리 편집 버튼 클릭
     * 트리 편집 모드로 전환한다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onTreeEditClick() {
      this.$store.commit('setDashboardViewMode', DashboardConst.VIEW_MODE.TREE_EDIT);
    },
    /**
     * 취소 버튼 클릭
     * 모니터링 모드로 전환한다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onCancleClick() {
      this.$confirm(...msgUtil.getCustomConfirmData('나가시겠습니까?'))
        .then(() => {
          this.exit();
        })
        .catch(() => {});
    },
    /**
     * 저장 버튼 클릭
     * 트리 편집 내용을 저장하고 모니터링 모드로 전환한다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onSaveClick() {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.SAVE))
        .then(() => {
          this.saveDashboardTree();
        })
        .catch(() => {});
    },
    /**
     * 대시보드 그룹 추가 버튼 클릭
     * 대시보드 그룹을 추가한다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} data [description]
     */
    addDashboardGroup() {
      const treeData = {
        gridDashboardTree: this.$refs.dashboardTree.$refs.gridDashboardTree.treeData,
        coordDashboardTree: this.$refs.dashboardTree.$refs.coordDashboardTree.treeData,
      };

      let dashboardType = DashboardConst.DASHBOARD_TYPE.GRID;

      try {
        // 현재 활성화 된 대시보드 트리에 따라 대시보드 구분 설정 (#52737)
        dashboardType = this.$refs.dashboardTree.activeTreeType.indexOf(DashboardConst.DASHBOARD_TYPE.GRID) > -1 ? DashboardConst.DASHBOARD_TYPE.GRID : DashboardConst.DASHBOARD_TYPE.COORD;
      } catch (e) {
        // ignore
      }

      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.DASHBOARD_GRP_SET, DashboardConst.SET_TYPE.ADD, treeData, dashboardType);
    },
    /**
     * 대시보드 트리 편집 내용 저장
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    saveDashboardTree() {
      this.isLoading = true;

      const gridDashboardTree = this.$store.getters.getDashboardTree(DashboardConst.DASHBOARD_TYPE.GRID);
      const coordDashboardTree = this.$store.getters.getDashboardTree(DashboardConst.DASHBOARD_TYPE.COORD);

      DashboardAPI.updateDashboardTree(gridDashboardTree, coordDashboardTree).then((response) => {
        const result = response.data;

        if (result.success) {
          this.$message('트리 설정을 저장하였습니다.');
          this.exit();
        } else {
          this.$message('트리 설정 저장을 실패하였습니다.');
        }
        this.isLoading = false;
      });
    },
    /**
     * 트리 편집 모드 나가기
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    exit() {
      // 대시보드를 다시 로드하기위해서 대시보드 ID값을 변경한다.
      this.dashboardData.dashboardId = -1;

      this.$store.commit('setDashboardViewMode', DashboardConst.VIEW_MODE.MONITORING);
      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.TREE_LOAD);
    },
  },
};
</script>

<style module>
.wrapper {
  height: 100%;
}
.tree {
  height: calc(100% - 55px) !important;
}
.tree-edit-btn {
  font-size: 15px;
  font-weight: 500;
  color: #999;
  height: 100%;
  width: 100%;
  text-align: center;
  vertical-align: middle;
  line-height: 55px;
}
.btn-bar {
  border-top: 1px solid #F0F0F0;
  height: 55px;
}
</style>
<style lang="scss">
.dashboard-list .lnb-nav .category-item {
  height: calc(100% - 36px) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/frame/DashboardList.vue